/**
 * @Description
 */

import { FC, useMemo } from 'react';
import { Table } from 'antd';
import styles from './index.module.less';
import { isNotEmptyAny } from '@lhb/func';

export const PPTColor = ['#358AFF', '#39D3F9', '#FFA140', '#5366F6', '#80D6EB', '#FFEB58', '#A896EF', '#AED0FF', '#96C2FF', '#7EB4FF', '#65A6FF', '#4E98FF', '#358AFF'];

const PPTTable:FC<any> = ({
  data
}) => {

  const dataSource = useMemo(() => {
    if (!isNotEmptyAny(data)) return [];

    const res = data.slice(0, 5).map((item: any, index: any) => {
      return { ...item, index: index + 1 };
    });

    return res;
  }, [data]);

  const columns = [
    {
      title: '排名',
      dataIndex: 'index',
      key: 'index',
    },
    {
      title: '业态',
      dataIndex: 'commercialName',
      key: 'commercialName',
      render(val: any, record: any) {
        const { index } = record;
        return (
          <div className={styles['commercial']}>
            <div className={styles['icon']} style={{ background: PPTColor[index] }}/>
            <div className={styles['name']}>{val}</div>
          </div>
        );
      }
    },
    {
      title: '占比',
      dataIndex: 'percent',
      key: 'percent',
    },
    {
      title: '门店数量',
      key: 'num',
      dataIndex: 'num',
    },
  ];
  return (
    <div className={styles['table-container']} style={{ width: '100%', height: '100%' }}>
      <Table columns={columns} dataSource={dataSource} pagination={false}/>
    </div>
  );
};

export default PPTTable;
